import {
  GET_DETAIL_PERMISSION_SUCCESS,
  GET_LIST_PERMISSION_SUCCESS,
  PAGINATION_DEFAULT,
  UPDATE_PERMISSION_SUCCESS,
} from "../../constants";
import { IPermissionState } from "../types";

interface ActionProps {
  type: string;
  payload: any;
}

const initState: IPermissionState = {
  list: {
    permissions: [],
    total: 0,
    limit: PAGINATION_DEFAULT.limit,
    offset: PAGINATION_DEFAULT.offset,
  },
  detail: {
    permissions: {},
  },
  isLoadingRequest: false,
  isDeleteRequest: false,
  isUpdateRequest: false,
  isCreateRequest: false,
};

const role = (state: IPermissionState = initState, action: ActionProps) => {
  const { type, payload } = action;

  switch (type) {
    case GET_LIST_PERMISSION_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          permissions: payload.data,
          total: payload.total,
        },
      };
    }

    case GET_DETAIL_PERMISSION_SUCCESS: {
      return {
        ...state,
        detail: {
          ...state.detail,
          permissions: payload.data,
        },
      };
    }

    case UPDATE_PERMISSION_SUCCESS: {
      return {
        ...state,
        detail: {
          ...state.detail,
          permissions: {},
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default role;
